module.exports = __webpack_public_path__ + "static/media/solution.f9e68547.jpg";